<template>
	<div class="home">
		<div class="head">
			<headerNavigation></headerNavigation>
		</div>
		<div class="carousel">
			<el-carousel :interval="4000" height="500px">
				<el-carousel-item v-for="(item, index) in carousel" :key="index">
					<img :src="item" style="width: 100%;height: 500px;">
				</el-carousel-item>
			</el-carousel>
		</div>
		<div class="menu">
			<div class="menulist" v-for="(item,index) in jingangList" :key="item.id" @click="goclassifi(item,index)">
				<div class="text">{{ item.classifyName }}</div>
				<img :src="item.classifyIcon" alt="" srcset="">
			</div>
		</div>
		<div style="padding: 0 200px;">
			<img src="../assets/ec5f57e9b9267639448d94b6fe0bbc0a.jpeg" style="width: 100%;height: 230px;">
		</div>
		<div style="margin: 0 200px 36px 200px;" v-for="item in recommendList" :key="item.id">
			<div class="star-title">
				<div class="title-left">{{ item.classifyName }}</div>
				<div class="title-right" @click="clickMore(item)">
					<div style="padding-right: 4px;">更多</div>
					<img src="../assets/next.png"></img>
					<img src="../assets/next.png"></img>
				</div>
			</div>
			<div class="card">
				<el-card shadow="hover" v-for="value in item.foodList" :key="value.id" @click="lookDetail(value)">
					<img :src="value.imageUrl" style="width: 320px;height: 210px;"/>
					<template #footer>
						<div>{{ value.foodName }}</div>
						<div class="price">￥ {{ value.price }}/{{ value.unitName }}</div>
					</template>
				</el-card>
				<div v-if="item.foodList == ''" style="display: flex;justify-content: center;width: 100%;">
					<div class="null">
					<img src="../assets/null.png" mode="widthFix" style="width: 120px;height: auto;">
					</img>
					<div class="tips">还没有商品哦~</div>
				</div>
				</div>
				
			</div>
			<div>
				<img src="../assets/5d1e49dddb43abf0724c59a6221bb1a7.jpeg" style="width: 100%;height: 400px;">
			</div>
		</div>
		<div class="foot">
			<headFoot></headFoot>
		</div>
	</div>
</template>

<script setup>
import headerNavigation from "../components/headNavgit.vue";
import headFoot from "../components/headFoot.vue"
import { ref, reactive, onMounted } from 'vue';
import { useRouter } from 'vue-router'
import { carouselInit, classify, recomclassify } from '../api/index'
onMounted(() => {
	image()
	classifyInit()
	recomclassiInit()
})
const carousel = ref('')
const jingangList = ref('')
const recommendList = ref('')
const router = useRouter()
const lookDetail = (e) => {
    router.push({
        name: 'goodsDetail',
        state: { goodsId: e.id }
    })
}
const image=()=> {
	carouselInit('').then(res => {
		carousel.value = res.data.carouselImagesUrl.split(',')
	})
}
const classifyInit=()=> {
	classify('').then(res => {
		jingangList.value = res.data
	})
}
const recomclassiInit=()=> {
	recomclassify('').then(res => {
		recommendList.value = res.data
	})
}

const goclassifi=(item,index)=> {
	console.log(item,index);
	router.push({
        name: 'class',
        state: { index}
    })
}
const clickMore=(item)=> {
	console.log(item);
	
	router.push({
        name: 'class',
        state: { classifyId:item.id,parentId:item.parentId}
    })
}
</script>
<style lang="scss" scoped>
.home {
	width: 100%;
	height: 100%;
	// background: linear-gradient(to bottom, #32cd32 0%, #f5f5f5 30%);
	// background-color: #f5f5f5;
}

.carousel {
	padding: 10px 200px 20px;
}

.el-carousel__item h3 {
	color: #475669;
	opacity: 0.75;
	line-height: 200px;
	margin: 0;
	text-align: center;
}

.el-carousel__item:nth-child(2n) {
	background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
	background-color: #d3dce6;
}

.menu {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 30px 200px 30px;

	.menulist {
		display: flex;
		flex-direction: column;
		align-content: center;
		justify-content: space-evenly;
		align-items: center;
		width: 160px;
		height: 200px;
		background: #f5f5f5;
		border-radius: 12px;
	}

	img {
		width: 64px;
		height: 64px;
	}

	.text {
		padding-left: 10px;
		font-size: 18px;
	}
}

.star-title {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 8px;
	padding: 40px 40px;
	// border-bottom: 2px solid #d3d3d3;

	.title-left {
		font-size: 30px;
		color: #32cd32;
		font-weight: 600;
	}

	.title-right {
		font-size: 14px;
		color: #7d7d7d;
		display: flex;
		align-items: center;

		img {
			width: 10px;
			height: 10px;
		}
	}
}

.card {
	display: flex;
	justify-content: space-between;
	align-items: center;
	flex-wrap: wrap;
	margin-bottom: 20px;

	.price {
		color: #bb0101;
		padding: 10px 0;
		font-weight: 600;
		font-size: 20px;
	}
}

.el-card {
	// margin: 0 30px 20px 0;
	width: 320px;
	border: none;
	border-radius: 12px;
}

:deep(.el-card__body) {
	text-align: center !important;
	padding: 0;
}
:deep(.el-card__footer) {
    padding: 10px;
    border-top: none;
    box-sizing: border-box;
}
</style>
